import React from 'react'
import {defineMessages, injectIntl} from 'react-intl'
import {connect} from 'react-redux'
import {Map, TileLayer} from 'react-leaflet'
import CM from 'leaflet-contextmenu'
import R from 'ramda'
import addPoiFromCoordinates from '../actions/addPoiFromCoordinates'

const tileUrl = 'http://tuile.lookupia.com/{z}/{x}/{y}.png'
const attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors | Algorithmes <a href="http://lookupia.com">Lookupia</a>'
const defaultStyle = {
  flexGrow: 1
}

const m = defineMessages({
  'Add a point of interest here': {id:'Add a point of interest here', defaultMessage: 'Add a point of interest here'},
})

class LKPMap extends React.Component {
  constructor(props){
    super(props)
    this.handleMapMoveBounded = this.handleMapMove.bind(this)
  }
   handleMapMove (event) {
      const bounds = event.target.getBounds()
      const zoom = event.target.getZoom()
      const topLeft = bounds.getNorthWest()
      const bottomRight = bounds.getSouthEast()
      const newBounds = {
        topLeft:{
          lat: topLeft.lat,
          lng: topLeft.lng
        },
        bottomRight: {
          lat: bottomRight.lat,
          lng: bottomRight.lng
        }
      }
      this.props.onMapMove(newBounds, zoom)
    }
  render() {
    const {style, defaultViewPort, onMapMove, onContextMenuPoiAdd} = this.props
    const s = {...defaultStyle, ...style}

    const bounds = [
      [ R.path(['topLeft', 'lat'], defaultViewPort), R.path(['topLeft', 'lng'], defaultViewPort)],
      [ R.path(['bottomRight', 'lat'], defaultViewPort), R.path(['bottomRight', 'lng'], defaultViewPort)],
    ]
    const props = {
      style:s,
      onMoveend:this.handleMapMoveBounded,
      contextmenu: true,
      contextmenuWidth: 180,
      contextmenuItems: [{
          text: this.props.intl.formatMessage(m['Add a point of interest here']),
          callback: onContextMenuPoiAdd
      }],
      bounds     
    }

    var map = <Map {...props}>
      <TileLayer url={tileUrl} attribution={attribution}/>
      {this.props.children}
    </Map>

    return map;
  }
} 

const coordinatePropTypes = React.PropTypes.shape({
  lat: React.PropTypes.number.isRequired,
  lng: React.PropTypes.number.isRequired,
})

LKPMap.propTypes = {
  defaultViewPort: React.PropTypes.shape({
    topLeft: coordinatePropTypes,
    bottomRight: coordinatePropTypes,
  }).isRequired,
  style: React.PropTypes.object,
  onMapMove: React.PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onContextMenuPoiAdd: e => dispatch(addPoiFromCoordinates(e.latlng))
  }
}

export default injectIntl(connect(null, mapDispatchToProps)(LKPMap))



/** WEBPACK FOOTER **
 ** ./app/components/Map.jsx
 **/